import ConditionType from './ConditionType'

const ConvergingCondition: ConditionType = {
  value: 'converging',
  label: 'Converging',
  hasRHS: true,
}

export default ConvergingCondition
